// @ts-nocheck
import {
  CREATE_COORDINATOR_FAILURE,
  CREATE_COORDINATOR_REQUEST,
  CREATE_COORDINATOR_SUCCESS,
  DELETE_COORDINATOR_FAILURE,
  DELETE_COORDINATOR_REQUEST,
  DELETE_COORDINATOR_SUCCESS,
  FETCH_ALL_COORDINATOR_FAILURE,
  FETCH_ALL_COORDINATOR_REQUEST,
  FETCH_ALL_COORDINATOR_SUCCESS,
  SEARCH_COORDINATOR_FAILURE,
  SEARCH_COORDINATOR_REQUEST,
  SEARCH_COORDINATOR_SUCCESS,
  TOGGLE_COORDINATOR_STATUS_FAILURE,
  TOGGLE_COORDINATOR_STATUS_REQUEST,
  TOGGLE_COORDINATOR_STATUS_SUCCESS,
  UPDATE_COORDINATOR_FAILURE,
  UPDATE_COORDINATOR_REQUEST,
  UPDATE_COORDINATOR_SUCCESS,
} from "../constants/coordinator";

const initialState = {
  coordinators: [],
  searchString: "",
  isLoading: false,
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
};

const coordinatorReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch all coordinators
    case FETCH_ALL_COORDINATOR_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true,
      };
    case FETCH_ALL_COORDINATOR_SUCCESS:
      return {
        ...state,
        coordinators: action?.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case FETCH_ALL_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // create a coordinator
    case CREATE_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_COORDINATOR_SUCCESS:
      return {
        coordinators: [{ ...action?.payload }, ...state.coordinators],
        isLoading: false,
      };
    case CREATE_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // update a coordinator
    case UPDATE_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_COORDINATOR_SUCCESS:
      return {
        coordinators: state.coordinators.map((coordinator) => {
          if (coordinator?._id === action.payload?._id) {
            return { ...action.payload };
          }
          return coordinator;
        }),
        isLoading: false,
      };
    case UPDATE_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // delete a coordinator
    case DELETE_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_COORDINATOR_SUCCESS:
      return {
        coordinators: state.coordinators.filter(
          (coordinator) => coordinator?._id !== action.payload,
        ),
        isLoading: false,
      };
    case DELETE_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // toggle coordinator status
    case TOGGLE_COORDINATOR_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };
    case TOGGLE_COORDINATOR_STATUS_SUCCESS:
      return {
        ...state,
        coordinators: state.coordinators.map((coordinator) => {
          if (coordinator?._id === action.payload?._id) {
            return { ...action.payload };
          }
          return coordinator;
        }),
        statusLoader: false,
      };
    case TOGGLE_COORDINATOR_STATUS_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    // search coordinator
    case SEARCH_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_COORDINATOR_SUCCESS:
      return {
        ...state,
        coordinators: action?.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case SEARCH_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default coordinatorReducer;
export {
  initialState
}